import clsx from 'clsx';
import styles from '../../styles/components/atoms/Tag.module.scss';

interface TagProps {
  label: string;
  dark?: boolean;
}

export default function Tag(props: TagProps) {
  const { label, dark } = props;
  const { tag } = styles;
  const classes = clsx(tag, { [styles.dark]: dark });

  return (
    <div className={classes}>
      <small>{label}</small>
    </div>
  );
}
